import React, { ChangeEvent, FC } from 'react'
import { Card, CardInner } from 'components/Card'
import { DeliveryFeeBySizeForm, RadioButton, SelectBox } from 'components/Form'
import { HorizontalLine, Spacer } from 'components/Utility'
import { HandledDeliveryFee, PackageSize } from 'types/storeDeliveryFee'
import { TextButton } from 'components/Button'
import { SelectOption } from 'types/common'

type Props = {
  addRegion: () => void
  addSize: (regionIndex: number) => void
  deliveryFees: HandledDeliveryFee[]
  feeType: 'bulk' | 'individual'
  handleDeliveryFeeAmount: (regionIndex: number, sizeIndex: number, event: ChangeEvent<HTMLInputElement>) => void
  handleFeeType: (event: ChangeEvent<HTMLInputElement>) => void
  isSelected: boolean
  label: string
  PACKAGE_SIZES: PackageSize[]
  regionNameOptions: SelectOption[]
  removeRegion: (regionIndex: number) => void
  removeSize: (regionIndex: number, sizeIndex: number) => void
  selectRegion: (regionIndex: number, regionName: string) => void
  selectSize: (regionIndex: number, sizeIndex: number, selectedSize: PackageSize) => void
}

const StoreDeliveryFeeCard: FC<Props> = (props) => {
  const {
    addRegion,
    addSize,
    deliveryFees,
    feeType,
    handleDeliveryFeeAmount,
    handleFeeType,
    isSelected,
    label,
    PACKAGE_SIZES,
    regionNameOptions,
    removeRegion,
    removeSize,
    selectRegion,
    selectSize,
  } = props
  return (
    <Card isOutlined={true}>
      <CardInner>
        <RadioButton isChecked={isSelected} label={label} onChange={handleFeeType} value={feeType} />
      </CardInner>
      {isSelected && (
        <>
          <HorizontalLine color={'grey03'} verticalMargin={16} />
          <CardInner>
            {deliveryFees.map((deliveryFee, regionIndex) => {
              const { sizes } = deliveryFee
              const addSizeDisabled = PACKAGE_SIZES.every((PACKAGE_SIZE) =>
                sizes.some((size) => size.package_size === PACKAGE_SIZE)
              )
              const disabledRemoveSize = feeType === 'bulk' && sizes.length === 1 && regionIndex === 0
              const enabledRemoveRegion = feeType === 'individual' && sizes.length === 1 && regionIndex !== 0
              const selectableRegionNameOptions = regionNameOptions.filter(
                (regionNameOption) =>
                  deliveryFees.every((_deliveryFee) => _deliveryFee.region_name !== regionNameOption.value) ||
                  regionNameOption.value === deliveryFee.region_name
              )
              return (
                <React.Fragment key={deliveryFee.region_name}>
                  {feeType === 'individual' && (
                    <>
                      <SelectBox<string>
                        disabled={regionIndex === 0}
                        options={selectableRegionNameOptions}
                        select={(value) => selectRegion(regionIndex, value)}
                        value={deliveryFee.region_name}
                      />
                      <Spacer size={20} />
                    </>
                  )}
                  <DeliveryFeeBySizeForm
                    disabledRemoveSize={disabledRemoveSize}
                    handleDeliveryFeeAmount={handleDeliveryFeeAmount}
                    PACKAGE_SIZES={PACKAGE_SIZES}
                    regionIndex={regionIndex}
                    removeRegion={enabledRemoveRegion ? removeRegion : undefined}
                    removeSize={removeSize}
                    selectSize={selectSize}
                    sizes={sizes}
                  />
                  <HorizontalLine color={'grey03'} verticalMargin={16} />
                  <TextButton
                    disabled={addSizeDisabled}
                    iconPath={addSizeDisabled ? '/icon/grey/plus.svg' : '/icon/blue/plus.svg'}
                    label={'サイズを追加する'}
                    onClick={() => addSize(regionIndex)}
                  />
                  {deliveryFees.length - 1 !== regionIndex && <Spacer size={20} />}
                </React.Fragment>
              )
            })}
            {feeType === 'individual' && (
              <>
                <HorizontalLine color={'grey03'} verticalMargin={16} />
                <TextButton iconPath={'/icon/blue/plus.svg'} label={'地域を追加する'} onClick={addRegion} />
              </>
            )}
          </CardInner>
        </>
      )}
    </Card>
  )
}

export default StoreDeliveryFeeCard
